import {
  EXTERNAL_USER,
  getAvatarInitials,
  getIsPhone,
  shouldUseInitialsForAvatar,
} from 'features/v2a/sender/helpers/Sender.helpers';
import React from 'react';
import {
  Size,
  UserAvatarTheme,
} from 'shared/components/vxl/avatar/UserAvatar/UserAvatar.helpers';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLineFormat } from 'shared/components/vxl/ListItem/ListItemTextStack';
import { VXLComponentId } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

interface RecipientListItemProps {
  id: string;
  title: string;
  subTitle?: string | null;
  avatarTheme: UserAvatarTheme | undefined;
  showVaroLogo?: boolean;
  onItemPress?: () => void;
  lineFormat?: Maybe<ListItemLineFormat>;
}

const RecipientListItem = ({
  id,
  title,
  subTitle,
  avatarTheme,
  showVaroLogo = false,
  onItemPress,
  lineFormat,
}: RecipientListItemProps) => {
  const avatarVariant = (id !== EXTERNAL_USER || getIsPhone(title)) && {
    ...{
      userAvatarVariant: {
        initials: shouldUseInitialsForAvatar(title)
          ? getAvatarInitials(title)
          : '',
      },
    },
  };
  return (
    <ListItem
      onPress={onItemPress}
      primaryCopy={title}
      secondaryCopy={subTitle}
      showsChevron={false}
      leadingAccessory={{
        id: id,
        name: VXLComponentId.USER_AVATAR,
        props: {
          userAvatarShowVaroLogo: showVaroLogo,
          userAvatarTheme: avatarTheme,
          userAvatarSize: Size.Medium,
          ...avatarVariant,
        },
      }}
      lineFormat={lineFormat}
    />
  );
};

export default RecipientListItem;
